import React from 'react';
import classes from './DecorativeButton.css';

const decorativeButton = (props) => {
    return <a href={props.to} target={props.target} className={classes.Dbtn}>{props.children}</a>;
};


export default decorativeButton;


// WEBPACK FOOTER //
// ./src/components/UI/DecorativeButton/DecorativeButton.js